import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CheckIcon from "@iconify/icons-mdi/check";
import CloseIcon from "@iconify/icons-mdi/close";
import ExclamationIcon from "@iconify/icons-mdi/exclamation";
import { InlineIcon } from "@iconify/react";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface MyHrDataEditCollapseHeaderBadgeProps {
  badgeName: "requested" | "approved" | "rejected" | string;
  border?: string;
}

export const MyHrDataEditCollapseHeaderBadge: React.FC<
  MyHrDataEditCollapseHeaderBadgeProps
> = ({ badgeName, border }) => {
  const theme = useTheme();
  const isMobile = useOcIsMobile();

  const getColor = (label: string) => {
    switch (label) {
      case "requested":
        return "#F3AA18";
      case "approved":
        return "#2FA84F";
      case "rejected":
        return theme.palette.primary.main;
      default:
        return "white";
    }
  };

  const iconMap = {
    requested: ExclamationIcon,
    rejected: CloseIcon,
    approved: CheckIcon,
  };

  const iconColor = getColor(badgeName);
  const IconComponent = iconMap[badgeName as keyof typeof iconMap];

  return (
    <>
      {isMobile && IconComponent && (
        <InlineIcon
          icon={IconComponent}
          width="24px"
          style={{
            color: iconColor,
            cursor: "pointer",
            border: border,
            borderRadius: 12,
            paddingLeft: isMobile ? 0 : 12,
            paddingRight: isMobile ? 0 : 12,
            paddingTop: isMobile ? 0 : 2,
            paddingBottom: isMobile ? 0 : 2,
            width: isMobile ? "20px" : "auto",
            height: isMobile ? "20px" : "auto",
            display: isMobile ? "flex" : "unset",
            alignItems: isMobile ? "center" : "unset",
          }}
        />
      )}
      {!isMobile && (
        <Box
          style={{
            color: theme.palette.gray80.main,
            border: border,
            borderRadius: 12,
            paddingLeft: 12,
            paddingRight: 12,
            paddingTop: 2,
            paddingBottom: 2,
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "space-around",
          }}
        >
          {badgeName}
        </Box>
      )}
    </>
  );
};

export default MyHrDataEditCollapseHeaderBadge;
